import type { Content, HeadlessContent } from '../../types';

export const mapHeadlessContent = (content: Content | HeadlessContent): Content => {
  if ('__type' in content && content.__type === 'aem-headless') {
    const normalisedContent: Content = {
      lightDarkMode: content.fields.lightDarkMode,
      headline: '',
    };
    return normalisedContent;
  }
  return content as Content;
};
